import * as React from "react";
const SvgQuantityMinus = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 3, y: 7.5, width: 10, height: 1, rx: 0.5, fill: "#EBEBEB" }));
export default SvgQuantityMinus;
